import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import "./CaratGateway.scss";
import { WebCache } from "../../services/WebCache";
import Page from "../containers/page";

interface IState {
    iframeUrl: string
}

interface IProps { }

let CaratGateway: React.FC<IProps> = () => {
    const T_PREFIX: string = 'pages.caratGateway.';
    const { t } = useTranslation();
    let [state, setState] = useState<IState>({
        iframeUrl: ""
    });

    useEffect(() => {
        const url = WebCache.getCaratGatewayUrl();
        setState(prevState => ({ ...prevState, iframeUrl: url }));
    }, []);

    return (
        <React.Fragment>
            <Page>
                <iframe className='caratGatewayFrame' src={state.iframeUrl}></iframe>
            </Page>
        </React.Fragment>
    );
};

export default CaratGateway;
